import { useState } from "react";
import { useRecoilState } from "recoil";
import { ConsoleTab, ConsoleTabsList } from "./ConsoleUi.style";
import ConsoleLogger from "./ConsoleLogger";
import { maximizeConsoleState } from "./ConsoleUi.state";

function TabPanel(props) {
    const { children, value, index } = props;

    return value === index 
        ? children
        : null
}


export default function ConsoleTabs() {
    const [value, setValue] = useState(0);
    const [max] = useRecoilState(maximizeConsoleState);

    const handleChange = (_, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <ConsoleTabsList
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
            >
                <ConsoleTab label="Websocket Events" />
            </ConsoleTabsList>
            <TabPanel value={value} index={0}>
                <ConsoleLogger className={max ? 'maximized' : ''} />
            </TabPanel>
        </>
    );
}